import * as React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { plural } from '@cian/utils';

import { UIHeading3, UIText1 } from '@cian/ui-kit';

import * as styles from './RecommendationsList.css';

interface IProps {
  children: React.ReactNode[];
}

export const RecommendationsList = ({ children }: IProps) => {
  const title = React.useMemo(() => {
    const count = children ? children.length : 0;

    return `${count} ${plural(count, ['объявление', 'объявления', 'объявлений'])}`;
  }, [children]);

  return (
    <>
      <UIHeading3>Рекомендации</UIHeading3>
      <UIText1>{title}</UIText1>
      <div className={styles['offers-list']}>{children}</div>
    </>
  );
};
